export enum AirportType {
    Large = 'large',
    Medium = 'medium',
    Small = 'small',
    SeaplaneBase = 'seaplane',
    Heliport = 'heliport',
    Closed = 'closed'
}
